export default __webpack_public_path__ + "static/media/mindmap_graphomotricite.2bfff3b2.jpg";